import vm from '~/main'

const pages = ({ isArray = false }) => {
  const web = vm && vm.localStorage.translations.pages
  const userType = vm && vm.$store.getters['user/userType']

  const planning = {
    toName: 'Planning',
    text: web.pages.buttons.planirovanie,
    icon: 'pages-planning',
    access:
      vm.$userCheckAccess({ abilities: 'view_general_schedule' }) ||
      vm.$userCheckAccess({ abilities: 'view_orders_volume' }),
    pages: [
      {
        toName: 'PlanningTableWork',
        icon: 'pages-planning-table_work',
        text: web.planning.pages['obem-zakazov'],
        access: vm.$userCheckAccess({ abilities: 'view_orders_volume' }),
      },
      {
        toName: 'PlanningGeneralSchedule',
        icon: 'pages-planning-general_schedule',
        text: web.planning.pages['obshchiy-grafik'],
        access: vm.$userCheckAccess({ abilities: 'view_general_schedule' }),
        hidden: 1000,
      },
    ],
  }

  const sales = {
    access: vm.$userCheckAccess({ abilities: 'view_sales' }),
    toName: 'sales',
    text: web.pages.buttons.prodazhi,
    icon: 'pages-projects-sales',
    pages: [
      {
        toName: 'Sales',
        text: web.sales.pages['vse-prodazhi'],
        icon: 'pages-projects-sales-all',
      },
      {
        toName: 'SalesArchive',
        text: web.sales.pages['arhiv'],
        icon: 'pages-projects-archive',
      },
    ],
  }
  const projects = {
    access: vm.$userCheckAccess({ abilities: 'view_projects' }),
    toName: 'projects',
    text: web.pages.buttons.proekty,
    icon: 'pages-projects',
    pages: [
      {
        toName: 'Projects',
        text: web.projects.pages['all'],
        icon: 'pages-projects',
      },
      {
        toName: 'TimeControl',
        text: web.projects.pages['statistics'],
        icon: 'pages-projects-statistic',
      },
      {
        toName: 'ProjectsReports',
        text: web.projects.pages['reports'],
        icon: 'pages-projects-reports',
        access: vm.$userCheckAccess({ abilities: 'view_project_reports' }),
      },
      {
        toName: 'ProjectsDone',
        text: web.projects.pages['archive'],
        icon: 'pages-projects-archive',
        access: vm.$userCheckAccess({ abilities: 'view_all_client_project' }),
      },
    ],
  }

  const personnel_department = {
    access: vm.$userCheckAccess({ abilities: 'view_hr' }),
    toName: 'Employees',
    text: web.pages.buttons['otdel-kadrov'],
    icon: 'pages-hr',
    pages: [
      {
        toName: 'employeesAll',
        text: web.personnel_department.pages.sotrudniki,
        icon: 'pages-hr-employees',
      },
      {
        toName: 'employeesGroup',
        text: web.personnel_department.pages.podrazdeleniya,
        icon: 'pages-hr-employees_group',
      },
    ],
  }

  const clients = {
    toName: 'clients',
    text: web.pages.buttons.clients,
    icon: 'pages-clients',
    access: vm.$userCheckAccess({ abilities: 'view_clients', checkUserType: 'user' }),
  }

  const finance = {
    toName: 'finance',
    text: web.pages.buttons['finance'],
    icon: 'pages-finance',
    access:
      vm.$userCheckAccess({ abilities: 'view_salary' }) ||
      vm.$userCheckAccess({ abilities: 'view_invoices' }),
    pages: [
      {
        toName: 'financeInvoice',
        text: web.finance.pages.invoice,
        icon: 'pages-finance-invoice',
        access: vm.$userCheckAccess({ abilities: 'view_invoices' }),
      },
      {
        toName: 'financeSalary',
        text: web.finance.pages.salary,
        icon: 'pages-finance-salary',
        access: vm.$userCheckAccess({ abilities: 'view_salary' }),
      },
    ],
  }

  const documents = {
    access: userType !== 'subscriber',
    toName: 'documents',
    text: web.setting.pages['free_documents'],
    icon: 'pages-documents',
    pages: [
      {
        toName: 'documentsPersonal',
        text: web['setting-free_documents'].pages.personal,
        icon: 'pages-documents-personal',
      },
      {
        toName: 'documentsAll',
        text: web['setting-free_documents'].pages.all,
        icon: 'pages-documents-all',
        access: vm.$userCheckAccess({ abilities: 'view_free_documents' }),
      },
    ],
  }
  const setting = {
    toName: 'Setting',
    text: web.pages.buttons['nastroyki'],
    icon: 'pages-settings',
    fullScreen: true,
    pages: [
      [
        {
          toName: 'SettingRoles',
          text: web.setting.pages['roli'],
          icon: 'pages-settings-roles',
          access: vm.$userCheckAccess({ abilities: 'view_roles' }),
          hidden: 1000,
        },
        {
          toName: 'SettingUsers',
          text: web.setting.pages['polzovateli'],
          icon: 'pages-settings-users',
          access: vm.$userCheckAccess({ abilities: 'view_users' }),
        },
        {
          toName: 'PersonalArea',
          text: web.setting.pages['lichnyy-kabinet'],
          icon: 'pages-settings-personal_area',
        },
        {
          toName: 'settingInterface',
          text: web.setting.pages['administrirovanie-interfeysa'],
          icon: 'pages-settings-interface',
          access: vm.$userCheckAccess({ checkUserType: 'superadmin' }),
          hidden: 1000,
        },
        {
          toName: 'settingLanguages',
          text: web.setting.pages['yazyk-interfeysa'],
          icon: 'pages-settings-languages',
        },
        {
          toName: 'settingOfferAgreement',
          text: web.setting.pages.offer_agreement,
          icon: 'pages-settings-offer_agreement',
          access: vm.$userCheckAccess({ checkUserType: 'superadmin' }),
          hidden: 1000,
        },
      ],
      [
        {
          toName: 'SettingBusinessSegment',
          text: web.setting.pages['segmenty-vida-deyatelnosti'],
          icon: 'pages-settings-business_segment',
          access: vm.$userCheckAccess({
            abilities: 'view_business_segments',
            checkUserType: 'user',
          }),
        },
        {
          toName: 'SettingProjectType',
          text: web.setting.pages['tipy-proektov'],
          icon: 'pages-settings-project_type',
          access: vm.$userCheckAccess({
            abilities: 'view_project_types',
            checkUserType: 'user',
          }),
        },
        {
          toName: 'SettingWorkTypesCategory',
          text: web.setting.pages['kategorii-rabot'],
          icon: 'pages-settings-work_types_category',
          access: vm.$userCheckAccess({
            abilities: 'view_work_type',
            checkUserType: 'user',
          }),
        },
        {
          toName: 'SettingWorkTypes',
          text: web.setting.pages['vidy-rabot'],
          icon: 'pages-settings-work_types',
          access: vm.$userCheckAccess({
            abilities: 'view_work_type',
            checkUserType: 'user',
          }),
        },
        {
          toName: 'SettingWorkExtraType',
          text: web.setting.pages['vidy-dopolnitelnyh-rabot'],
          icon: 'pages-settings-work_extra_type',
          access: vm.$userCheckAccess({
            abilities: 'view_work_extra_types',
            checkUserType: 'user',
          }),
        },
        {
          toName: 'SettingWorkRegion',
          text: web.setting.pages['regiony'],
          icon: 'pages-settings-work_region',
          access: vm.$userCheckAccess({
            abilities: 'view_regions',
            checkUserType: 'user',
          }),
        },
        {
          toName: 'SettingEmployeeRoles',
          text: web.setting.pages['dolzhnosti'],
          icon: 'pages-settings-employee_roles',
          access: vm.$userCheckAccess({
            abilities: 'view_work_roles',
            checkUserType: 'user',
          }),
        },
        {
          toName: 'SettingWorkDocsSchemeType',
          text: web.setting.pages['tip-chertezha'],
          icon: 'pages-settings-scheme_type',
          access: vm.$userCheckAccess({
            abilities: 'view_scheme_types',
            checkUserType: 'user',
          }),
        },
        {
          toName: 'SettingWorkDocsDocumentType',
          text: web.setting.pages['tip-dokumenta'],
          icon: 'pages-settings-document_type',
          access: vm.$userCheckAccess({
            abilities: 'view_document_types',
            checkUserType: 'user',
          }),
        },
        {
          toName: 'SettingWorkDocsWorkArea',
          text: web.setting.pages['zona-raboty'],
          icon: 'pages-settings-work_area',
          access: vm.$userCheckAccess({
            abilities: 'view_work_areas',
            checkUserType: 'user',
          }),
        },
        {
          toName: 'SettingWorkDocsSchemeClass',
          text: web.setting.pages['soderzhanie-chertezhey'],
          icon: 'pages-settings-scheme_class',
          access: vm.$userCheckAccess({
            abilities: 'view_scheme_classes',
            checkUserType: 'user',
          }),
        },
        {
          toName: 'SettingFinance',
          text: web.pages.buttons.finance,
          icon: 'pages-finance',
          access: vm.$userCheckAccess({
            checkUserType: 'superadmin',
          }),
        },
        {
          toName: 'SettingOfferTemplate',
          text: web['sales_project']['price_offer_terms-labels'].templates,
          icon: 'pages-settings-templates',
          access: vm.$userCheckAccess({
            abilities: 'edit_default_content_settings',
          }),
        },
      ],
      [
        {
          toName: 'SettingStructureCompany',
          text: web.setting.pages['structure_company'],
          icon: 'pages-settings-structure_company',
          access: vm.$userCheckAccess({
            abilities: 'edit_work_roles',
            checkUserType: 'user',
          }),
        },
        {
          toName: 'SettingCompany',
          text: web.setting.pages['setting_company'],
          icon: 'pages-settings-company',
          access:
            vm.$userCheckAccess({
              abilities: ['edit_general_settings'],
            }) ||
            vm.$userCheckAccess({
              abilities: ['edit_geo_position_settings'],
            }) ||
            vm.$userCheckAccess({
              abilities: ['edit_start_stop_settings'],
            }) ||
            vm.$userCheckAccess({
              abilities: ['edit_mobile_calendar_settings'],
            }) ||
            vm.$userCheckAccess({
              abilities: ['edit_financial_settings'],
            }),
        },
        {
          toName: 'settingsPushNotifications',
          text: web.setting.pages['push_notifications'],
          icon: 'pages-settings-push_notifications',
          access: vm.$userCheckAccess({
            abilities: 'view_notifications',
            checkUserType: 'user',
          }),
        },
      ],
    ],
  }

  return vm
    ? !isArray
      ? {
          planning,
          sales,
          projects,
          personnel_department,
          clients,
          finance,
          documents,
          setting,
        }
      : [planning, sales, projects, personnel_department, clients, finance, documents, setting]
    : null
}

export default pages
